import { Component, OnInit } from '@angular/core';
import { OidPenPackagesService } from '../../../../../../services/oid-pen-packages.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UserService } from '../../../../../../services/user.service';

@Component({
    selector: 'app-oid-pen-packages-categories',
    templateUrl: './oid-pen-packages-categories.component.html',
    styleUrls: ['./oid-pen-packages-categories.component.scss'],
    standalone: false
})
export class OidPenPackagesCategoriesComponent implements OnInit {
  loading = false;
  okLoading = false;
  categories: any[] = [];
  displayCategories: any[] = []; // Tree structured
  userInfo: any;

  // Form related
  modalVisible = false;
  modalTitle = '新增分类';
  editId: number | null = null;
  form = {
    name: '',
    pid: 0,
    seq: 10,
    description: '',
    cover: '',
    schoolId:  0,
  };

  constructor(
    private oidPenPackagesSvc: OidPenPackagesService,
    private message: NzMessageService,
    private modal: NzModalService,
    private userSvc: UserService
  ) {
    this.userInfo = this.userSvc.getUserInfo();
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.oidPenPackagesSvc.getSyllabus().then(res => {
      this.loading = false;
      this.categories = this.extractListData(res);
      this.displayCategories = this.categories;
    }).catch(() => {
      this.loading = false;
      this.message.error('加载分类失败');
    });
  }

  private extractListData(res: any): any[] {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.rows)) return res.rows;
    if (Array.isArray(res.list)) return res.list;
    if (res.data) {
      if (Array.isArray(res.data.list)) return res.data.list;
      if (Array.isArray(res.data.rows)) return res.data.rows;
    }
    return [];
  }

  openAdd(): void {
    this.modalTitle = '新增分类';
    this.editId = null;
    this.form = {
      name: '',
      pid: 0,
      seq: 10,
      description: '',
      cover: '',
      schoolId: this.userInfo?.school_id || 0
    };
    this.modalVisible = true;
  }

  openEdit(item: any): void {
    this.modalTitle = '编辑分类';
    this.editId = item.id;
    this.form = {
      name: item.name,
      pid: item.pid || 0,
      seq: item.seq,
      description: item.description || '',
      cover: item.cover || '',
      schoolId: item.schoolId || this.userInfo?.school_id || 0
    };
    this.modalVisible = true;
  }

  handleCancel(): void {
    this.modalVisible = false;
  }

  handleOk(): void {
    if (!this.form.name) {
      this.message.warning('请输入分类名称');
      return;
    }

    this.okLoading = true;
    const saveAction = this.editId
      ? this.oidPenPackagesSvc.updateSyllabus(this.editId, this.form)
      : this.oidPenPackagesSvc.createSyllabus(this.form);
    const t1 = Date.now();
    saveAction.then(res => {
      const now = Date.now();
      const delta = Math.max(0, 1000 - (now - t1));
      setTimeout(() => {
        this.okLoading = false;
        this.message.success(this.editId ? '更新成功' : '创建成功');
        this.modalVisible = false;
        this.loadCategories();
      }, delta);
    }).catch((err) => {
      this.okLoading = false;
      this.message.error(err.message || '操作异常');
    });
  }

  deleteCategory(id: number): void {
    this.modal.confirm({
      nzTitle: '确认删除该分类吗？',
      nzContent: '删除后无法恢复，且可能影响关联的文章。',
      nzOkText: '确认',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.loading = true;
        const t1 = Date.now();
        this.oidPenPackagesSvc.deleteSyllabus(id).then(() => {
          const now = Date.now();
          const delta = 1000 - (now - t1);
          setTimeout(() => {
            this.loading = false;
            this.message.success('删除成功');
            this.loadCategories();
          }, delta)
        }).catch(err => {
          this.message.error(err.message || '删除失败');
        });
      }
    });
  }
}
